import { FindAStoreData, TranslationData } from "@/common/lib/types";
import FindStore from "../common/FindStore";
import HeaderVariants from "../common/headerVariants/HeaderVariants";

interface IProps {
  storeData: FindAStoreData;
  translations: TranslationData;
  locale: string;
}
const CLPFindStore = ({ storeData, translations, locale }: IProps) => {
  return (
    <section className={`container flex flex-col items-center gap-[3px] lg:px-12`}>
      <h2 className="mb-[13px] text-center text-size-22 font-medium md:mb-4 md:text-xl">
        {storeData?.title}
      </h2>
      <HeaderVariants
        variant="withSubheading"
        subheading={storeData?.description}
        translations={translations}
        bgClassName="p-0 mb-[18px] md:mb-9 "
      />
      <FindStore
        locale={locale}
        isCLP={true}
        storeData={{
          auxiliaryText: storeData?.auxiliaryText,
          media: storeData.media,
          findStore: storeData?.cta && {
            link: storeData?.cta?.link,
            title: storeData?.cta?.title,
          },
        }}
      />
    </section>
  );
};

export default CLPFindStore;
